import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, getNoCatch, post } from '@api/request';
import { stffAPI } from '@api/modules/staff';
import { cpttAPI } from '@api/modules/cptt';
import { optnAPI } from '@api/modules/optn';
import editHeader from '@/views/component/editHeader';
import inputUser from '@/views/component/inputUser';
import MoudSmplList from '@/views/PurchaseManagement/MoudManage/TabChild/Componet/MoudSmplList.vue';
import MoudMdrlImport from '@/views/PurchaseManagement/MoudManage/TabChild/Componet/MoudMdrlImport.vue';
import { moudAPI } from '@api/modules/moud';
import { cloneDeep } from 'lodash';
export default {
  name: 'moudEditMain',
  components: {
    editHeader: editHeader,
    inputUser: inputUser,
    MoudSmplList: MoudSmplList,
    MoudMdrlImport: MoudMdrlImport
  },
  data: function data() {
    var validatePrice = function validatePrice(rule, value, callback) {
      if (value > 999999.9999) {
        callback(new Error('总金额不能大于999999.9999'));
      }

      callback();
    };

    return {
      rules: {
        sour_price: [{
          validator: validatePrice
        }],
        sour_no: [{
          required: true,
          trigger: 'blur',
          message: ' '
        }],
        cptt_id: [{
          required: true,
          trigger: 'change',
          message: ' '
        }],
        cptt_address: [{
          required: true,
          trigger: 'change',
          message: ' '
        }],
        sour_deli_time: [{
          required: true,
          trigger: 'change',
          message: ' '
        }],
        extra_price: [{
          pattern: /^\d{0,4}(\.\d{1,4})?$/,
          message: '最大只能输入9999.9999并且只能输入数字且最多4位小数!'
        }]
      },
      moudForm: {},
      isShow: true,
      btn: {},
      stffForm: {},
      stffType: [],
      selectChangeList: [],
      mtrlTypeGroupOpt: [],
      cpttList: [],
      smplFlag: false,
      mdrlFlag: false,
      title: '物料信息',
      totalPrice: null,
      loadingFlag: true,
      moudCopy: []
    };
  },
  created: function created() {
    this.initData();
  },
  watch: {},
  methods: {
    initData: function initData() {
      this.getsourInfo();
      this.getStffType();
      this.getCpttV1();
      this.getMtrlType();
      this.loadingFlag = true;
    },
    //启用编辑
    openEdit: function openEdit() {
      this.isShow = false;
      this.$emit('isShow', this.isShow);
    },
    //撤销编辑
    closeEdit: function closeEdit() {
      var _this = this;

      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this.isShow = true;

        _this.$emit('isShow', _this.isShow);

        _this.initData();

        _this.$message({
          type: 'info',
          message: '已撤销编辑!'
        });
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this.$message({
          message: mg,
          type: tp
        });
      });
    },
    //提交表单
    submit: function submit(formName) {
      var _this2 = this;

      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$refs[formName].validate(function (valid) {
          if (valid) {
            _this2.saveInfo();
          } else {
            console.log('error submit!');
            return false;
          }
        });
      });
    },
    // 保存
    saveInfo: function saveInfo() {
      var _this3 = this;

      var moudForm = {};
      moudForm = Object.assign(moudForm, this.moudForm);
      console.log('moub_form', this.moudForm);
      moudForm.moud_deli_time = parseInt(Number(moudForm.moud_deli_time) / 1000);
      console.error(333, moudForm.moud_mtrl_list);
      moudForm.moud_mtrl_list = Object.assign(moudForm.moud_mtrl_list, this.moudCopy);
      console.log(222, moudForm);
      post(moudAPI.editmoud, moudForm).then(function (res) {
        if (res.data.code === 0) {
          _this3.$message({
            type: 'success',
            message: '保存成功'
          });

          _this3.isShow = true;

          _this3.$emit('isShow', _this3.isShow);

          _this3.initData();
        } else if (res.data.code === 7) {
          _this3.$message({
            type: 'error',
            message: '申请单号重复'
          });

          moudForm.moud_deli_time = Number(moudForm.moud_deli_time) * 1000;
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this3.$message({
            message: mg,
            type: tp
          });

          _this3.initData();

          moudForm.moud_deli_time = Number(moudForm.moud_deli_time) * 1000;
        }
      });
    },
    //取消
    cancel: function cancel() {
      var _this4 = this;

      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this4.resetForm('sourForm');

        _this4.$router.go(-1);

        _this4.$message({
          type: 'info',
          message: '已取消新增!'
        });
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this4.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 计算价格
    calcPriceOne: function calcPriceOne(num) {
      var posi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var str = arguments.length > 2 ? arguments[2] : undefined;
      var num1 = 0;
      var fre = Math.pow(10, posi);
      num1 = Math.floor(num * fre) / fre;

      if (isNaN(num1)) {
        return 0;
      } else {
        if (num1 >= str) {
          this.$message({
            type: 'error',
            message: '总金额不能大于1000000'
          });
          return '';
        } else {
          var value = num1;
          value = value.toString();

          if (value) {
            var ind = value.toString().indexOf('.');

            if (ind < 0) {
              return value + '.0000';
            } else {
              if (value.length - 1 - ind > 4) {
                return value.splice(ind + 5);
              } else if (value.length - 1 - ind < 4) {
                var index = 4 - (value.length - 1 - ind);

                for (var i = 0; i < index; i++) {
                  value = value + '0';
                }

                return value;
              } else {
                return value;
              }
            }
          }
        }
      }
    },
    // 刷新按钮
    buttonRefresh: function buttonRefresh() {
      this.initData();
    },
    // cptt变化选择地址编号
    cpttChange: function cpttChange(val) {
      var temp = {};
      temp = this.cpttList.filter(function (item) {
        return item.cptt_id === val;
      });

      if (temp.length === 1) {
        this.moudForm.cptt_address = temp[0].cptt_address;
        this.moudForm.cptt_no = temp[0].cptt_no;
      }
    },
    // 打开弹框
    smplImport: function smplImport() {
      this.smplFlag = true;
    },
    // 导入传值
    mdrlConfirm: function mdrlConfirm(val) {
      var find = this.moudForm.moud_mtrl_list.some(function (x) {
        return x.mdrl_id === val.mdrl_id;
      });

      if (find) {
        this.$message({
          message: '禁止添加相同的物料信息',
          type: 'warning'
        });
      } else {
        var temp = cloneDeep(val);
        temp.mtrl_num = null;
        this.moudForm.moud_mtrl_list.push(temp);
        this.emptyDisable = false;
        this.smplFlag = false;
      }
    },
    // 取消选择
    childSmplChanel: function childSmplChanel() {
      this.smplFlag = true;
    },
    falseBom: function falseBom() {
      this.childSmplChanel();
    },
    // 样品list清单多选删除
    delBom: function delBom() {
      var _this5 = this;

      if (this.selectChangeList.length > 0) {
        this.moudForm.moud_mtrl_list = this.moudForm.moud_mtrl_list.filter(function (item) {
          return _this5.selectChangeList.every(function (item1) {
            return item.mdrl_id !== item1.mdrl_id;
          });
        });

        for (var i = 0; i < this.selectChangeList.length; i++) {
          for (var j = 0; j < this.moudCopy.length; j++) {
            if (this.selectChangeList[i].mdrl_id === this.moudCopy[j].mdrl_id) {
              this.moudCopy[j].destroy_flag = 1;
            }
          }
        }

        var price = 0.0; //总金额

        var price1 = 0.0; //额外金额

        console.log(555555555, this.moudForm.moud_mtrl_list);
        var mdrlList = this.moudForm.moud_mtrl_list;

        for (var _i = 0; _i < mdrlList.length; _i++) {
          if (mdrlList[_i].mtrl_num && mdrlList[_i].no_mdrl_price) {
            price += parseInt(Number(mdrlList[_i].no_mdrl_price) * 10000) * parseInt(Number(mdrlList[_i].mtrl_num) * 10000) / 10000 / 10000;
            price1 += parseInt(Number(mdrlList[_i].no_mdrl_price - mdrlList[_i].mdrl_price) * 10000) * parseInt(Number(mdrlList[_i].mtrl_num) * 10000) / 10000 / 10000;
          }
        }

        price = parseInt(Number(price) * 1000000);
        price1 = parseInt(Number(price1) * 1000000);
        this.moudForm.moud_price = price / 1000000;
        this.moudForm.extra_price = price1 / 1000000;
        console.error(this.moudForm);

        if (this.moudForm.moud_mtrl_list.length === 0) {
          this.totalPrice = 0;
        }
      } else {
        this.$message.warning('至少选择一条信息');
      }
    },
    // 样品单list选择
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectChangeList = val;
    },
    // 更改价格
    sourPrice: function sourPrice(val, val2) {
      var price = parseInt(Number(val) * 1000000);
      var price1 = parseInt(Number(val2) * 1000000); //let price2 = parseInt(Number(this.moudForm.extra_price) * 1000000)

      this.moudForm.moud_price = price / 1000000;
      this.moudForm.extra_price = price1 / 1000000;
      this.totalPrice = JSON.parse(JSON.stringify(val));
    },
    // 获取委托人
    getStffType: function getStffType() {
      var _this6 = this;

      get(stffAPI.getAllStffsV1).then(function (res) {
        if (res.data.code === 0) {
          _this6.stffType = res.data.data;
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this6.$message({
          message: mg,
          type: tp
        });
      });
    },
    //表单重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取公司信息
    getCpttV1: function getCpttV1() {
      var _this7 = this;

      get(cpttAPI.getAllCpttsV2).then(function (res) {
        if (res.data.code === 0) {
          _this7.cpttList = res.data.data;
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this7.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 获取单位
    getMtrlType: function getMtrlType() {
      var _this8 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10005
      }).then(function (res) {
        if (res.data.code === 0) {
          _this8.mtrlTypeGroupOpt = res.data.data;
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this8.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 获取表单信息
    getsourInfo: function getsourInfo() {
      var _this9 = this;

      this.moudForm.moud_id = this.$route.query.form_id;
      getNoCatch(moudAPI.getMoudById, {
        moud_id: this.moudForm.moud_id
      }).then(function (_ref) {
        var data = _ref.data;
        _this9.moudForm = data.form;
        _this9.moudForm.moud_deli_time = Number(_this9.moudForm.moud_deli_time) * 1000;
        _this9.moudCopy = JSON.parse(JSON.stringify(_this9.moudForm.moud_mtrl_list));
        _this9.btn = data.btn;
        _this9.moudForm.mdrl_price = _this9.helper.haveFour(_this9.moudForm.mdrl_price);
        _this9.moudForm.extra_price = _this9.helper.haveFour(_this9.moudForm.extra_price);
        _this9.stffForm.stff_name = _this9.moudForm.stff_name;
        _this9.stffForm.dept_name = _this9.moudForm.dept_name;
        _this9.stffForm.dept_team_name = _this9.moudForm.dept_team_name;
        _this9.stffForm.user_id = _this9.moudForm.user_id;
        _this9.stffForm.dept_id = _this9.moudForm.dept_id;
        _this9.stffForm.stff_id = _this9.moudForm.stff_id;
        _this9.totalPrice = data.form.moudForm - data.form.extra_price;
        setTimeout(function () {
          _this9.loadingFlag = false;
        }, 500);
      });
    }
  }
};